<template>
  <div class="header-container">
    <!-- 导航 -->
    <div class="header_nav  w" :class="!isLogin?'unLogin':''">
      <router-link class="nav_logo" to="/">
        <img :src="config.logo" :alt="config.site_title" class="pointer logo-img" />
        <span class="logo-divider"></span>
        <span class="logo-sub">一手资源供应商</span>
      </router-link>

      <div class="nav_right">
        <div class="nav_group">
          <div class="nav-group-left">
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         exact
                         active-class="nav-active"
                         to="/">后台首页
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/index/hotmedia">
              <img class="nav-hot" src="https://newsosssts.oss-cn-shanghai.aliyuncs.com/avatar/190/cfecdb276f634854f3ef915e2e980c31.png" alt="">
              优选GEO
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/index/article">软文价格
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/index/zimeiti">自媒体推广
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/index/video">短视频价格
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         :class="{'nav-active': isPublishRoute}"
                         to="/index/create">文章发布
            </router-link>
            <router-link v-if="profile.recharge===1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/recharge_center">我要充值
            </router-link>
          </div>
        </div>
      </div>
      <div class="head_top_right">
        <div class="header-slogan">
          <img src="../../assets/home/icon-bell.png" alt="">
          <span>一手资源</span>
        </div>
<!--        <router-link class="header-extra" to="/home">
          <img src="../../assets/home/icon-front-home.png" alt="">
          前台首页
        </router-link>-->
        <span class="header-split"></span>
<!--        <a class="header-extra" :href="config.indexHost" target="_blank">在线咨询</a>-->
        <el-popover
            placement="bottom-end"
            width="274"
            trigger="hover">
          <div class="user" slot="reference">
            <img class="header-avatar" :src="profile.avatar" alt="">
            {{ profile.name?profile.name:profile.mobile }}
            <i class="el-icon-caret-bottom" style="font-size: 14px;padding-left: 4px;">

            </i>
          </div>
          <div class="user-popover">


            <div class="user-popover-links">

              <a class="user-popover-link-item" href="/own/finance/invoice_list">
                <svg-icon
                  icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                  style="width: 14px;height: 12px;margin-right: 8px;" />
                发票中心
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
              <a class="user-popover-link-item" href="/own/personal/profile">
                <svg-icon
                    icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                    style="width: 14px;height: 12px;margin-right: 8px;" />
                资料编辑
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
              <a class="user-popover-link-item" href="/own/personal/password">
                <svg-icon
                  icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                  style="width: 14px;height: 12px;margin-right: 8px;" />
                修改密码
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
            <div class="logout">
              <a @click="onLogout" class="pointer">退出登录</a>
            </div>
          </div>
        </el-popover>
      </div>
    </div>

  </div>

</template>

<script>
import * as Cookies from 'js-cookie'

export default {
  data() {
    return {
      person: {},
      index: 0,
      show: true
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile
    },
    isLogin() {
      return this.$store.state.auth.isLogin
    },
    taxonomies() {
      return this.$store.state.taxonomy
    },
    urlCallback() {
      return escape(document.URL)
    },
    isPublishRoute() {
      return ['/index/create', '/own/publish_multi', '/own/publish_batch'].includes(this.$route.path)
    }
  },
  created() {
    if (this.$route.path.split('/')[1] == 'resource') {
      this.show = true
    } else if (this.$route.path.split('/')[1] == 'cart') {
      this.show = true
    } else {
      this.show = false
    }
  },
  methods: {
    onLogout() {
      let loadingInstance = this.$loading({
        text: '注销中...'
      })

      this.$http
          .post('/auth/logout', {device: 'pc'})
          .then(response => {
            if (response.success) {
              //Cookies.remove("bearer");
              window.location.href = '/login'
            }
          })
          .catch()
          .then(() => {
            this.$nextTick(() => {
              loadingInstance.close()
            })
          })
    }
  }
}

</script>

<style scoped lang="scss">
@import './../../../config.scss';

/* 头部 */


.header-container {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 999;
  height: 60px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.head {
  background-color: $--head-background;
  -webkit-box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
  -moz-box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
  box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
}

.head.unLogin {
  background-color: $--color-primary;
  position: fixed;
  width: 100%;
  z-index: 100;

  .head_top {
    color: #fff;
    text-align: center;
    justify-content: center;

    .btn {
      border: 1px solid #fff;
      padding: 3px 10px;
      color: #fff;
      border-radius: 2px;

      &:first-child {
        margin-right: 12px;
      }
    }
  }
}

.head_top {
  width: 1200px;
  font-size: 12px !important;
  height: 38px;
  color: $--head-color;
  display: flex;
  justify-content: space-between;
  min-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.head_top_left {
  padding-left: 20px;
}

.head_top_right {
  padding-right: 25px;
  font-size: 16px;
  color: #666;
  display: flex;
  align-items: center;

  .user {
    height: 100%;
    display: flex;
    align-items: center;
    color: rgba(17, 17, 17, 1);
    font-size: 14px;
  }

  .header-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }

  .header-slogan {
    height: 28px;
    background: transparent;
    border-radius: 0;
    border: none;
    display: flex;
    align-items: center;
    padding: 0;
    margin-right: 24px;
    color: #FC6429;
    font-size: 13px;
    line-height: 24px;
    white-space: nowrap;

    img {
      width: 13px;
      height: 12px;
      margin-right: 8px;
    }
  }

  .header-extra {
    display: flex;
    align-items: center;
    color: rgba(17, 17, 17, 1);
    font-size: 14px;
    line-height: 24px;
    white-space: nowrap;
    text-decoration: none;

    img {
      width: 13px;
      height: 14px;
      margin-right: 5px;
    }
  }

  .header-split {
    width: 1px;
    height: 10px;
    background-color: rgba(142, 146, 152, 1);
    margin: 0 12px;
  }
}

.user-popover {
  padding: 8px;

  .user-info-box {
    display: flex;
    align-items: center;

    > img {
      width: 45px;
      margin-right: 14px;
    }
  }

  .balance-box {
    width: 230px;
    height: 46px;
    background: #F1F4F6;
    border-radius: 6px;
    display: flex;
    align-items: center;
  }

  .user-popover-links {
    margin-top: 12px;
    padding-bottom: 10px;
    background: url("https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/shadow.png") no-repeat center bottom;

    .user-popover-link-item {
      height: 38px;
      padding: 0 16px;
      display: flex;
      align-items: center;
    }
  }

  .logout {
    height: 35px;
    padding-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.head_top_right > span {
  margin-right: 5px;
}

.head_top_right a {
  color: $--head-color;
}

.head_top_right > span:last-child {
  margin-right: 0;
}

.head_top ul {
  /* float: right; */
  margin-right: 48px;
}

.head_top ul li {
  float: left;
  /* margin-left: 10px; */
  font-size: 14px;
  line-height: 35px;
}

.head_top .tel {
  float: right;
  height: 35px;
  line-height: 40px;
}

.head_top_right a.active {
  color: #FF0000;
}

.head_top_right a.emphasize {
  color: #0082E6;
}

/* 导航 */

.header_nav {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.header_nav.unLogin {
  padding-top: 38px;
}

.header_nav .nav_logo {
  padding-left: 25px;
  width: auto;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;

  .logo-img {
    width: 115px;
    height: 31px;
    object-fit: contain;
  }

  .logo-divider {
    width: 2px;
    height: 12px;
    background-color: rgba(17, 17, 17, 1);
    margin: 0 13px 0 15px;
  }

  .logo-sub {
    color: rgba(17, 17, 17, 1);
    font-size: 16px;
    line-height: 16px;
    white-space: nowrap;
  }
}


.header_nav .nav_right {
  flex: 1;
}

.nav_group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav-group-left {
  padding-left: 40px;
  flex: 1;
  display: flex;
  align-items: center;
}


.nav-group-right {
  display: flex;
  justify-content: flex-end;
}

.nav_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  height: 60px;
  padding: 0 12px;
  border-radius: 0;
  margin-right: 2px;
  color: #333;
  position: relative;

  .nav-hot {
    position: absolute;
    left: 50%;
    top: 2px;
    width: 35px;
    height: 18px;
    margin-left: 0;
    pointer-events: none;
    animation: nav-hot-bob 1.8s ease-in-out infinite;
  }

}

@keyframes nav-hot-bob {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-3px);
  }
}


.per_center_right ul {
  width: 496px;
  /* margin-right: 36px; */
}

.nav_btn.nav-active {
  background: transparent;
  color: #FF4B2B;
  font-weight: 700;
  border-radius: 0;

  &::after {
    content: "";
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 0;
    height: 2px;
    background: #FF4B2B;
    border-radius: 2px;
  }
}

.per_center_right li {
  font-size: 14px;
  color: #434343;
  float: left;
  /* width: 20%; */
  text-align: center;
  line-height: 57px;
  padding: 21px 15px 0;
}

.per_center_right li > a {
  color: #333333;
}

.make_recharge, .user-center {
  width: 110px;
  background: #5185FF;
  color: #fff;
  font-size: 14px;

  i {
    margin-right: 4px
  }
}

.make_recharge {
  background: #ffa800;
}

.header-nav {
  display: flex;
  justify-content: space-between;
}

.header-nav > div {
  margin-left: 278px;
}

.header-nav > div > li {
  margin-right: 20px;
}

.steps {
  display: flex;
  height: 90px;
  justify-content: center;
  align-items: center;
}

.step-item {
  width: 200px;
}

.step-item:nth-child(4) {
  width: 17%;
}

.step-item > span {
  color: #999999;
  font-size: 16px;
}

.step-item > span:first-child {
  display: inline-block;
  width: 35px;
  height: 35px;
  background-color: #c9c9c9;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  color: #ffffff;
}

.step-item > span:nth-child(3) {
  margin-left: 20px;
}

.steps > .active > span:nth-child(1) {
  background-color: $--color-primary;
}

.steps > .active > span:nth-child(2) {
  color: $--color-primary;
}

</style>



// WEBPACK FOOTER //
// src/components/global/Header.vue